var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-container"},[_c('YlCarousel',{attrs:{"height":"200px","typeParams":_vm.typeParams}}),_c('CableRawList',{attrs:{"columns":_vm.columns,"broadHead":_vm.broadHead}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }